<template>
  <div class="my-2">
    <div class="" :style="leftStyle">
      {{label}}:
    </div>
    <div class="pl-2" :style="rightStyle">
      <slot/>
    </div>
  </div>
</template>
<script>
import { } from 'mdbvue';
export default {
  name: 'LabelText',
  components: {},
  props: ['label', 'width'],
  data: () => ({
    TAG: 'LabelText :'
  }),
  computed: {
    leftStyle () {
      return {
        display: 'table-cell',
        width: this.width,
        'font-weight': 900
      }
    },
    rightStyle () {
      return {
        display: 'table-cell',
        width: 'auto'
      }
    }
  }
}
</script>
